module.exports = __webpack_public_path__ + "static/img/logo.ece5acf.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo.gif
// module id = BhpG
// module chunks = 6